<template>
  <div>
    <div class="d-flex mb-3 align-items-end">
      <h1 class="h4 primary--text">
        {{ $t('views.supplier_list.title') }}
      </h1>
      <div class="ml-auto">
        <v-btn
          outlined
          large
          @click="toggleFilter"
        >
          <v-icon left>
            mdi-filter-variant
          </v-icon>
          {{ $t('common.filter') }}
        </v-btn>
      </div>
    </div>
    <suppliers-filter
      v-model="isFilterShown"
      :filter="filter"
      @applyFilter="applyFilter"
    />
    <v-data-table
      fixed-header
      :headers="headers"
      :items="items"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50, 100],
      }"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      :loading-text="$t('common.loading_data')"
    >
      <template v-slot:item.isLocal="{ item }">
        {{ item.isLocal ? $t('common.yes') : $t('common.no') }}
      </template>
      <template v-slot:item.physicalCountry="{ item }">
        {{ item.physicalCountry && item.physicalCountry.code }}
      </template>
      <template v-slot:item.isConsolidator="{ item }">
        {{ item.isConsolidator ? $t('common.yes') : $t('common.no') }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-hover v-slot:default="{hover}">
          <v-icon
            :class="hover ? '' : 'text--disabled'"
            color="primary"
            size="20"
            @click="showSupplier(item.asdb)"
          >
            mdi-open-in-new
          </v-icon>
        </v-hover>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import SuppliersFilter from '@/components/suppliers/SuppliersFilter.vue';
import { mongoRegexI } from '@/utils/mongo-regex';

export default {
  name: 'SupplierList',

  components: {
    SuppliersFilter,
  },

  data() {
    return {
      userModal: false,
      userSelected: null,
      modalType: 'add',
      total: 0,
      items: [],
      loading: false,
      options: {
        page: 1,
      },

      headers: [
        { text: this.$t('common.name'), value: 'name' },
        { text: 'ASDB', value: 'asdb' },
        { text: this.$t('views.supplier_list.local'), value: 'isLocal' },
        { text: this.$t('views.supplier_item.country'), value: 'physicalCountry' },
        { text: this.$t('views.supplier_item.isConsolidator'), value: 'isConsolidator' },
        {
          text: this.$t('common.actions'), value: 'actions', sortable: false, width: 150, align: 'center',
        },
      ],

      filter: {
        name: '',
        asdb: '',
        isLocal: null,
        physicalCountry: '',
      },
      isFilterShown: false,
    };
  },

  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },

  methods: {
    showSupplier(asdb) {
      this.$router.push(`supplier/${encodeURIComponent(asdb)}`);
    },

    async getItems() {
      this.loading = true;

      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;

      const filter = this.mapFilter();

      const params = {
        query: filter,
        pageSize: itemsPerPage,
        page,
        populate: 'physicalCountry',
      };

      if (sortBy.length) {
        params.sort = `${sortDesc[0] ? '-' : ''}${sortBy[0]}`;
      }

      try {
        const { data = {} } = await this.$http.get('suppliers', { params });
        this.items = data.rows;
        this.total = data.total;
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loading = false;
      }
    },

    toggleFilter() {
      this.isFilterShown = !this.isFilterShown;
    },

    applyFilter(filter) {
      this.filter = { ...filter };
      this.options.page = 1;
      this.getItems();
    },

    mapFilter() {
      const filter = {};
      if (this.filter.name) {
        filter.name = mongoRegexI(this.filter.name);
      }
      if (this.filter.asdb) {
        filter.asdb = mongoRegexI(this.filter.asdb);
      }
      if (this.filter.isLocal !== null) {
        filter.isLocal = this.filter.isLocal;
      }
      if (this.filter.physicalCountry) {
        filter.physicalCountry = this.filter.physicalCountry;
      }
      return filter;
    },
  },
};
</script>
